import { createFileRoute } from '@tanstack/react-router'
import { isFieldUser } from '@/auth/me'
import { PublicQueue } from '@/features/queue/public-queue'
import { StaffBoard } from '@/features/queue/staff-board'

export const Route = createFileRoute('/_app/queue')({
  validateSearch: (s: Record<string, unknown>): { relux?: string } => ({
    relux: typeof s.relux === 'string' ? s.relux : undefined,
  }),
  component: Queue,
})

function Queue() {
  const { me } = Route.useRouteContext()
  const { relux } = Route.useSearch()
  return isFieldUser(me) ? <PublicQueue /> : <StaffBoard me={me} selected={relux} />
}
